
import { defineComponent } from 'vue';

export default defineComponent({
  props: ['arealist', 'loading'],
  setup() {
    const getSummaries = function(param: any) {
      const { columns, data } = param
      const sums: any = []
      columns.forEach((column: any, index: number) => {
        if (index === 0) {
          sums[index] = '合 計'
          return
        }else if(index === 3) { // 単価は合計しない
          sums[index] = ''
          return
        }
        const values = data.map((item: any) => Number(item[column.property]));
        if(!values.every((value: any) => isNaN(value))) {
          sums[index] = values.reduce((prev: any, curr: any) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if(column.property === "text") {
          sums[index] = data.length + 'エリア'
        }
      })
      return sums
    }

    return {
      getSummaries
    }
  }
})
